import ReactModal from 'react-modal';
import General from '../utils/GeneralUtils';
import './EmailVerificationSlideout.scss';
import './RankExplanationSlideout.scss';

const RANK_BANDS = [
  {
    range: '75-100',
    representativeRank: 85,
    tier: 3,
    label: 'Executive',
    description: 'Senior leadership roles such as Superintendent, Principal, C-suite executives, and other top decision-makers.',
    examples: 'Superintendent, Principal, CEO, CFO, Chancellor',
  },
  {
    range: '50-74',
    representativeRank: 60,
    tier: 2,
    label: 'Senior Management',
    description: 'Directors, administrators, and managers who oversee departments or major functions.',
    examples: 'Director, Dean, Administrator, Manager',
  },
  {
    range: '25-49',
    representativeRank: 35,
    tier: 1,
    label: 'Mid-Level',
    description: 'Coordinators, specialists, and supervisors who manage specific programs or teams.',
    examples: 'Coordinator, Specialist, Supervisor, Counselor',
  },
  {
    range: '0-24',
    representativeRank: 18,
    tier: 0,
    label: 'Staff',
    description: 'Teachers, support staff, and other frontline roles.',
    examples: 'Teacher, Aide, Secretary, Technician',
  },
];

interface RankExplanationSlideoutProps {
  isOpen: boolean;
  onClose: () => void;
}

export function RankExplanationSlideout({ isOpen, onClose }: RankExplanationSlideoutProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
      style={General.getSliderDefaults({ width: 'min(90vw, 450px)' })}
      parentSelector={General.getModalRoot}
    >
      <div className="email-verification-slideout">
        <div className="header">
          <h3>Role Rank</h3>
        </div>

        <div className="section intro">
          <p>Rank is a score from 0-100 that reflects the seniority of a role. It's based on the role type, with adjustments for modifiers (e.g., "Assistant" reduces rank) and status (e.g., "Former" reduces rank).</p>
        </div>

        <div className="section all-statuses">
          <table>
            <tbody>
              {RANK_BANDS.map((band, index) => (
                <tr key={band.range}>
                  <td className="status-cell">
                    <span
                      className={`rank-badge rank-badge--tier-${band.tier}`}
                      style={{ '--rank-percent': `${band.representativeRank}%` } as React.CSSProperties}
                    >
                      {band.range}
                    </span>
                  </td>
                  <td className="desc">
                    <strong>{band.label}</strong>
                    <br />
                    <span style={{ fontSize: '0.75rem', marginTop: '4px', display: 'inline-block' }}>{band.description}</span>
                    <br />
                    <span style={{ fontSize: '0.75rem', color: 'var(--amplify-colors-font-tertiary)' }}>
                      e.g., {band.examples}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </ReactModal>
  );
}
